/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';
import { LuisAppStore } from 'src/luis/core/stores/LuisAppStore';

type LuisMigratedAppStoreData = OmitFunctions<Partial<Omit<LuisMigratedAppStore, 'id'>>>;

export class LuisMigratedAppStore {
    public readonly id: string;

    public readonly key: string;

    public readonly name: string;

    public readonly culture: string;

    @observable public luisApp: LuisAppStore;

    @observable public selectedVersion: string;

    @observable public loadedVersions: string[];

    @observable public areVersionsLoading: boolean;

    @observable public isDataLoading: boolean;

    constructor(id: string, data?: LuisMigratedAppStoreData) {
        this.id = id;
        this.key = id;
        this.name = data.name;
        this.culture = data.culture;
        this.luisApp = { ...data.luisApp } as LuisAppStore;
        this.selectedVersion = data.selectedVersion;
        this.loadedVersions = [...data.loadedVersions];
        this.areVersionsLoading = false;
        this.isDataLoading = false;
    }

    @action
    public setIsDataLoading(isDataLoading: boolean) {
        this.isDataLoading = isDataLoading;
    }

    @action
    public setLoadedVersions(loadedVersions: string[]) {
        this.loadedVersions = [...loadedVersions];
    }

    @action
    public setAreVersionsLoading(areVersionsLoading: boolean) {
        this.areVersionsLoading = areVersionsLoading;
    }

    @action
    public setSelectedVersion(selectedVersion: string) {
        this.selectedVersion = selectedVersion;
    }
}
